import { Stack } from '@mui/material';
import Container from '@mui/material/Container';
import { Outlet } from 'react-router-dom';

import { NotForAdminsAlert } from '@/components/NotForAdminsAlert';
import { PageTitle } from '@/components/PageTitle';

export const SpotterSetupLayout = () => {
    return (
        <Container maxWidth="lg">
            <PageTitle title="Register Spotter" />
            <NotForAdminsAlert />
            <Stack>
                <Outlet />
            </Stack>
        </Container>
    );
};
